import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { useEffect } from "react";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { zodResolver } from "@hookform/resolvers/zod";

import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import dayjs from "dayjs";
import { InspecaoPatrimonioModel } from "../../../../domain/models/inspecao_patrimonio";
import { InspecaoPatrimonioForm, InspecaoPatrimonioSchema } from "../../../schemas/InspecaoPatrimonio_cadastro/inspecao_patrimonio_cadastro";

/**
 * InspecaoObraModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectecInspecaoPatrimonio: InspecaoPatrimonioModel | null,
  onClose: () => void;
  onSubmit: (form: InspecaoPatrimonioForm) => void;
};

export const InspecaoPatrimonioModal = ({
  open,
  saving,
  loading,
  selectecInspecaoPatrimonio,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<InspecaoPatrimonioForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(InspecaoPatrimonioSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectecInspecaoPatrimonio) {
        hookForm.setValue('dataInspecao', dayjs(selectecInspecaoPatrimonio.dataInspecao).toDate());
        hookForm.setValue('descricao', selectecInspecaoPatrimonio.descricao);
      } else {
        hookForm.reset();
        hookForm.setValue('dataInspecao', new Date());
      }
    }
  }, [
    open,
    selectecInspecaoPatrimonio,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      width="50rem"
      title='Verificação de Inspeção'
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title="Informações" arrangement="fullRow">
        <>
          <FormDatePickerInput
            name='dataInspecao'
            label='Data da Inspeção'
            required={true}
            reactHookForm={hookForm}
          />

          <DefaultFormInput
            name='descricao'
            label='Descrição'
            multiline={true}
            rows={4}
            required={false}
            reactHookForm={hookForm}
          />

        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
}